
import { Navigation } from "@/components/Navigation";
import { Card, CardContent } from "@/components/ui/card";
import { Footer } from "@/components/Footer";
import { Milestone, Rocket, Trophy, Gem, Users } from "lucide-react";
import {SEO} from "@/components/SEO.tsx";
import React from "react";

const Roadmap = () => {
  const milestones = [
    {
      phase: "Phase 1 - Launch",
      date: "Q2 2025",
      icon: <Rocket className="w-6 h-6" />,
      title: "Platform Launch",
      items: [
        "Initial platform development",
        "Construction of the scoring system",
        "Security audits",
        "Poll creator services",
      ]
    },
    {
      phase: "Phase 2 - Growth",
      date: "Q3 2025",
      icon: <Users className="w-6 h-6" />,
      title: "Community Expansion",
      items: [
        "Mobile application improvements",
        "Community building",
        "Partnership announcements",
        "Benefit program Launch",
        "Premium features improvements",
        "Advanced analytics dashboard for partners",
      ]
    },
    {
      phase: "Phase 3 - Features",
      date: "Q4 2025",
      icon: <Gem className="w-6 h-6" />,
      title: "Enhanced Features",
      items: [
        "Advanced polling mechanisms",
        "Start of Rewards and Benefits Program",
        "Cross-chain compatibility",
        "Expanding the partner network"
      ]
    },
    {
      phase: "Phase 4 - Scale",
      date: "Q1 2026 and beyond",
      icon: <Trophy className="w-6 h-6" />,
      title: "Platform Scaling",
      items: [
        "Global marketing campaign",
        "Transition to token economy",
        "The process of tokenizing earned points",
        "Smart contract deployment"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white dark:bg-background">
      <SEO
          title="Roadmap"
          description="Explore our development roadmap and future plans"
          type="website"
          name="blankpoll"
          imageUrl="/blankpoll-banner.jpg"
      />
      <Navigation />

      <div className="container mx-auto pt-24 px-4 pb-16">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4 dark:text-white">Project Roadmap</h1>
            <p className="text-gray-600 dark:text-gray-300">
              Discover our journey and future plans as we build the future of decentralized prediction platforms
            </p>
          </div>

          <div className="space-y-8">
            {milestones.map((milestone, index) => (
              <Card key={index} className="dark:bg-gray-800/50 dark:border-gray-700">
                <CardContent className="p-6">
                  <div className="flex items-center gap-6">
                    <div className="flex-shrink-0 w-16 h-16 rounded-full bg-primary/10 dark:bg-gray-700 flex items-center justify-center dark:text-gray-300">
                      {milestone.icon}
                    </div>

                    <div className="flex-1">
                      <div className="flex items-center justify-between mb-4">
                        <div>
                          <h3 className="text-xl font-semibold dark:text-white">{milestone.phase}</h3>
                          <p className="text-gray-600 dark:text-gray-300">{milestone.title}</p>
                        </div>
                        <span className="px-4 py-1 rounded-full bg-primary/10 dark:bg-gray-700 text-sm font-medium dark:text-gray-300">
                          {milestone.date}
                        </span>
                      </div>

                      <ul className="space-y-2">
                        {milestone.items.map((item, itemIndex) => (
                          <li key={itemIndex} className="flex items-center gap-2">
                            <Milestone className="w-4 h-4 text-primary dark:text-gray-300" />
                            <span className="dark:text-gray-300">{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Roadmap;
